import { AfterViewInit, Component, inject } from '@angular/core';
import { LfMainMenuComponent } from '@leafio/ui/layout';
import { LfToastsOutlet } from '@leafio/ui/toasts';
import { RouterOutlet } from '@angular/router';
import { InitialLoaderService } from '@services/initial-loader/initial-loader';
import { MenuService } from '@services/menu-service/menu-service';

@Component({
  selector: 'app-root',
  imports: [LfMainMenuComponent, RouterOutlet, LfToastsOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  protected menu = inject(MenuService);

  ngAfterViewInit() {
    InitialLoaderService.hide();
  }
}
